import './Table.scss';
import directiveTemplate from 'text!./Table.html';
import overlayTemplate from 'text!./Overlay.html';

var getDefaultItemState = function getDefaultItemState() {
    return {
        removing: false
    };
};

export default [function () {
    return {
        restrict: 'E',
        scope: {
            schedule: '&'
        },
        template: directiveTemplate,
        controller: ['$scope', 'ModalService', function ($scope, ModalService) {
            $scope.$watch('schedule()', function (schedule) {
                var itemStates = new Map();
                var dropRemoves = function dropRemoves() {
                    return itemStates.forEach(function (item) {
                        item.removing = false;
                    });
                };
                var createDefaultState = function createDefaultState(item) {
                    return itemStates.set(item, getDefaultItemState(item));
                };
                schedule.getScheduledItems().forEach(createDefaultState);

                $scope.initRemove = function (item) {
                    dropRemoves();
                    itemStates.get(item).removing = true;
                };
                $scope.cancelRemoving = function (item) {
                    itemStates.get(item).removing = false;
                };
                $scope.isBeingRemoved = function (item) {
                    return itemStates.get(item).removing;
                };
                $scope.remove = function (item) {
                    schedule.remove(item);
                    itemStates.delete(item);
                };

                var _showOverlay = function _showOverlay(item, isNewLocation) {
                    dropRemoves();

                    item.draft();

                    var _onBeforeCommit = void 0;
                    ModalService.showSimpleDialog(overlayTemplate, {
                        schedule: schedule,
                        scheduledItem: item,
                        isNewLocation: isNewLocation,
                        onBeforeCommit: function onBeforeCommit(cb) {
                            _onBeforeCommit = cb;
                        }
                    }, {
                        undo: function undo(dialogScope) {
                            item.undo();
                            dialogScope.$dismiss();
                        },
                        commit: function commit(dialogScope) {
                            var beforeCommitValid = typeof _onBeforeCommit === 'function' ? _onBeforeCommit() : true;
                            if (!item.isValid() || !beforeCommitValid) {
                                dialogScope.shouldShowErrors = true;
                            } else {
                                item.commit();
                                if (isNewLocation) {
                                    createDefaultState(item);
                                    schedule.add(item);
                                }

                                dialogScope.$dismiss();
                            }
                        }
                    }, null, {
                        wide: true,
                        keyboard: false
                    });
                };

                $scope.edit = function (item) {
                    _showOverlay(item, false);
                };
                $scope.createNew = function () {
                    _showOverlay(schedule.createNewItem(), true);
                };
            });
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/scheduleTypes/editable/LocationTable/LocationTable.js
// module id = 287
// module chunks = 0